import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";

import CustomerDataSection from "./CustomerDataSection";

const MarketingData = ({ businessObjects, strings, urls }) => {
  const text = useMemo(() => [...strings, ...urls], [strings, urls]);

  return (
    <Tile style={{ height: 400 }}>
      <TileHeader>
        <TileTitle>Marketing Data</TileTitle>
      </TileHeader>
      <TileBody>
        {!!businessObjects.length && (
          <CustomerDataSection title="Category" data={businessObjects} />
        )}

        {!!text.length && <CustomerDataSection title="Text" data={text} />}
      </TileBody>
    </Tile>
  );
};

MarketingData.propTypes = {
  businessObjects: PropTypes.array,
  strings: PropTypes.array,
  urls: PropTypes.array
};

MarketingData.defaultProps = {
  businessObjects: [],
  strings: [],
  urls: []
};

export default MarketingData;
